import { createContext } from "react";

const DataContext = createContext<any>({});

export default DataContext;